/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 */

import { createRpcClientV2 } from 'rpc-client-utils';
import portalsHttpClient from 'portals-platform-lib/portalsHttpClient';
import { defineResource } from 'pulse/resources';
import { fromRPC } from 'pulse/adapters';
import * as References from './ThreadViewRpc';
const chirpClient = createRpcClientV2({
  hubHttpClient: portalsHttpClient
});

// RPC Resources

export const GetRelevantThreadsForUserRpc = defineResource({
  typeName: 'com.hubspot.support.portal.rpc.ThreadViewRpc.getRelevantThreadsForUser',
  args: ['params', 'membershipToken', 'utkCookie', 'portalInstanceId', 'accountId', 'objectId', 'membershipCsrfTokenFromClient', 'membershipCsrfTokenFromCookie', 'previewJwt', 'companyId', 'tolerateInstanceAccessDenied'],
  resolver: fromRPC({
    rpc: References.getRelevantThreadsForUserRpc,
    rpcClient: chirpClient
  })
}).register();
export const GetThreadViewRpc = defineResource({
  typeName: 'com.hubspot.support.portal.rpc.ThreadViewRpc.getThreadView',
  args: ['params', 'membershipToken', 'utkCookie', 'portalInstanceId', 'accountId', 'objectId', 'membershipCsrfTokenFromClient', 'membershipCsrfTokenFromCookie', 'previewJwt', 'companyId', 'tolerateInstanceAccessDenied'],
  resolver: fromRPC({
    rpc: References.getThreadViewRpc,
    rpcClient: chirpClient
  })
}).register();